// @flow
import React from 'react';
import PropTypes from "prop-types";
import {Modal, ModalManager, Effect} from 'react-dynamic-modal';
import Tinput from "./Tinput";
import t from '../trans';
import Notification from "./Notification";


const propTypes = {
    onClickOk: PropTypes.func,
    onClickCancel: PropTypes.func,
    okText: PropTypes.string,
    cancelText: PropTypes.string,
    title: PropTypes.string,
    noCancel: PropTypes.bool,
    showNotifications: PropTypes.bool,
    disabled: PropTypes.bool
};

const defaultProps = {
    okText: 'OK',
    cancelText: 'Cancel',
    noCancel: false,
    showNotifications: false,
    disabled: false
};

class AuthModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            password: ""
        };
        this.onClickOk = this.onClickOk.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onClose = this.onClose.bind(this);
        this.goToPasswordField = this.goToPasswordField.bind(this);
    }

    componentDidMount() {
        this.goToUserField();
    }

    onClose() {
        if (this.props.noCancel) return false;

        if (this.props.onClickOk) {
            this.props.onClickOk(this.state.username, this.state.password);
            return false;
        }
        else return true;
    }

    onClickOk(e) {
        e.preventDefault();
        if (this.props.onClickOk) this.props.onClickOk(this.state.username, this.state.password);
        else ModalManager.close();
    }

    onClickCancel(e) {
        e.preventDefault();
        if (this.props.onClickCancel) this.props.onClickCancel();
        else ModalManager.close();
    }

    onChange(param, value) {
        this.setState({
            [param]: value
        });
    }

    goToPasswordField(e) {
        e.preventDefault();
        let el = document.getElementById("password");
        el.focus();
        el.select();
    }

    goToUserField() {
        let el = document.getElementById("username");
        el.focus();
        el.select();
    }

    render() {
        return (
            <Modal effect={Effect.ScaleUp} className="modal-dialog" style={{content:{width:'400px'}}} onRequestClose={this.onClose} data-keyboard={ this.props.noCancel ? "false" : "true"}>
                <div className="modal-header">
                    {this.props.noCancel ?
                        null :
                        (<button type="button" className="close" onClick={this.onClickCancel} aria-label="Close">
                            <i className="fa fa-times" aria-hidden="true"/>
                         </button>)
                    }
                    <h4 className="modal-title">{this.props.title}</h4>
                </div>
                <div className="modal-body">
                    {this.props.showNotifications ?
                        (<Notification onlyLast={true}/>)
                        : null
                    }
                    <form className="form-horizontal">
                        <div className="form-group">
                            <label htmlFor="username" className="col-sm-4 control-label">{t("Username")}</label>
                            <div className="col-sm-7">
                                <Tinput className="form-control"
                                        id="username"
                                        type="text"
                                        valueType="string"
                                        value={this.state.username}
                                        onChange={this.onChange}
                                        onChangeParam="username"
                                        onEnter={this.goToPasswordField}
                                        disabled={this.props.disabled}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="password" className="col-sm-4 control-label">{t("Password")}</label>
                            <div className="col-sm-7">
                                <Tinput className="form-control"
                                        id="password"
                                        type="password"
                                        valueType="string"
                                        value={this.state.password}
                                        onChange={this.onChange}
                                        onChangeParam="password"
                                        onEnter={this.onClickOk}
                                        disabled={this.props.disabled}
                                />
                            </div>
                        </div>
                    </form>
                </div>

                <div className="modal-footer">
                    {this.props.noCancel ?
                        null :
                        (<button type="button" className="btn btn-default"
                                 onClick={this.onClickCancel}
                                 disabled={this.props.disabled}
                        >{this.props.cancelText}</button>)
                    }
                    <button type="button" className="btn btn-primary"
                            onClick={this.onClickOk}
                            disabled={this.props.disabled}
                    >{this.props.okText}</button>
                </div>
            </Modal>
        );
    }
}

AuthModal.propTypes = propTypes;
AuthModal.defaultProps = defaultProps;

export default AuthModal;
